import { InjectionToken } from '@angular/core';
import { Context } from './models/overlay.interface';


export const OVERLAY_CONTEXT = new InjectionToken<Context>('OVERLAY_CONTEXT');
